import type { KyInstance } from 'ky';

import { ensureError } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { Tooltip } from './types/tooltip.type';

/**
 * Fetches a list of tooltips from the API.
 *
 * @param instance - The Ky HTTP client instance used to make the request.
 * @returns A promise that resolves to an {@link OperationResultWithData} containing
 * an array of {@link Tooltip} objects.
 * @throws Throws an error if the request fails.
 */
export const getTooltips = async (instance: KyInstance) => {
  try {
    return await instance.get<OperationResultWithData<Tooltip[]>>(Uri.tooltip.get, {}).json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
